import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'students',
    name: 'student',
    component: Index,
    title: 'student',
    redirect: { name: 'student-list' },
    children: [
      {
        path: 'list',
        name: 'student-list',
        component: List,
      },
      
    ],
  },
]
